import { useContext } from "react";
import { RmcContext } from "../../context/RmcContext";
import Points from "../../points/Points";
import { ProfileBadge } from "./ProfileBadge";
import { Avatar } from "../../Avatar";
import clsx from "clsx";
import { getValidImageUrl } from "../../../utils";

const Header = ({ className, customBgColor }) => {
  const { rmcAudience } = useContext(RmcContext);
  const imageUrl = getValidImageUrl(
    rmcAudience?.audience_badge_image_url,
    "/image/BronzeMedal.png",
  );

  return (
    <div
      className={clsx(
        "overflow-y-hidden flex justify-between items-center pt-10 pb-10 px-4 rounded-t-[30px]",
        className,
      )}
    >
      <div className="flex items-center gap-2">
        {rmcAudience?.user_image ? (
          <ProfileBadge image={rmcAudience?.user_image} />
        ) : (
          <Avatar
            firstName={rmcAudience?.first_name}
            lastName={rmcAudience?.last_name}
            size="sm"
            customBgColor={customBgColor ?? "#FFD700"}
            customTextColor="#000"
          />
        )}
        <div>
          <p className="text-sm font-medium text-white">{`${
            rmcAudience?.first_name || "Anonymous"
          }`}</p>
          <div className="bg-[#0000004D] py-1.5 px-1.5  rounded-full flex items-center gap-1 justify-center">
            <img
              src={imageUrl}
              alt={rmcAudience?.audience_badge_name}
              className="w-2.5 h-3 object-contain"
              loading="lazy"
            />
            <span className="text-[0.5rem] font-bold text-[#FFFFFFBF]">
              {rmcAudience?.audience_badge_name}
            </span>
          </div>
        </div>
      </div>
      <Points
        className="bg-[#00000066]"
        userPoints={rmcAudience?.points || 0}
      />
    </div>
  );
};

export default Header;
